import React from 'react';
import { cn, inferGender } from '../../lib/utils';
import { EXPERT_REGISTRY } from '../../lib/constants';

// Person avatar SVG components
function MaleAvatar({ color = '#A1A1AA' }) {
  return (
    <svg viewBox="0 0 36 36" fill="none" className="w-full h-full">
      {/* Head */}
      <circle cx="18" cy="12" r="7" fill={color} opacity="0.9" />
      {/* Body */}
      <path
        d="M8 32C8 25.373 13.373 20 20 20H16C22.627 20 28 25.373 28 32"
        fill={color}
        opacity="0.7"
      />
      {/* Shoulders */}
      <ellipse cx="18" cy="28" rx="12" ry="6" fill={color} opacity="0.7" />
    </svg>
  );
}

function FemaleAvatar({ color = '#A1A1AA' }) {
  return (
    <svg viewBox="0 0 36 36" fill="none" className="w-full h-full">
      {/* Head */}
      <circle cx="18" cy="11" r="7" fill={color} opacity="0.9" />
      {/* Hair */}
      <path
        d="M11 11C11 7 14.5 3 18 3C21.5 3 25 7 25 11C25 9 23 7 18 7C13 7 11 9 11 11Z"
        fill={color}
        opacity="0.5"
      />
      {/* Body */}
      <ellipse cx="18" cy="28" rx="10" ry="7" fill={color} opacity="0.7" />
    </svg>
  );
}

export function ExpertAvatar({ name, size = 48, showTooltip = true }) {
  const expert = EXPERT_REGISTRY[name];
  const gender = expert?.gender || inferGender(name);
  const color = expert?.color || '#A1A1AA';
  
  return (
    <div
      className={cn(
        'relative rounded-full flex items-center justify-center',
        'bg-[#161619] overflow-hidden'
      )}
      style={{ 
        width: size, 
        height: size,
        border: `2px solid ${color}20`
      }}
      title={showTooltip ? `${name}${expert?.role ? ` - ${expert.role}` : ''}` : undefined}
    >
      {gender === 'female' ? (
        <FemaleAvatar color={color} />
      ) : (
        <MaleAvatar color={color} />
      )}
    </div>
  );
}

export function ExpertAvatarRow({ experts, maxShow = 5, size = 48 }) {
  const displayExperts = experts.slice(0, maxShow);
  const remaining = experts.length - maxShow;

  return (
    <div className="flex items-center">
      {displayExperts.map((name, index) => (
        <div
          key={name}
          className={cn(
            'relative transition-all duration-200',
            'hover:-translate-y-1 hover:scale-110 hover:z-10',
            index > 0 && '-ml-2'
          )}
          style={{ zIndex: displayExperts.length - index }}
        >
          <ExpertAvatar name={name} size={size} />
        </div>
      ))}
      
      {remaining > 0 && (
        <div
          className={cn(
            'w-12 h-12 rounded-full -ml-2',
            'flex items-center justify-center',
            'bg-[#1F1F23] border-2 border-[#08080A]',
            'text-[12px] font-semibold text-[#71717A]'
          )}
        >
          +{remaining}
        </div>
      )}
    </div>
  );
}
